export default __webpack_public_path__ + "static/media/hht1_ep18_minisitcom_02.7e7276f0.png";